const cardItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20warm%20vintage%20tones%2C%20classic%20movie%20poster%20aesthetic%2C%20dramatic%20portrait%20lighting%2C%20film%20noir%20atmosphere%2C%20subtle%20grain%20texture%2C%20artistic%20composition&width=600&height=400&seq=card-01&orientation=landscape',
    title: '久久视频高分电影榜 · 口碑佳作一次看完',
    desc: '精选IMDb与豆瓣高分电影，久久视频稳定片源，高清画质配流畅播放，观影体验满分。',
    alt: '久久视频高分电影推荐',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20vibrant%20characters%20in%20dynamic%20poses%2C%20Japanese%20animation%20aesthetic%2C%20bright%20saturated%20colors%2C%20action%20scene%20composition%2C%20clean%20modern%20art%20style&width=600&height=400&seq=card-02&orientation=landscape',
    title: '小蓝视频动漫专区 · 日漫国漫随心切换',
    desc: '海量正版动漫资源，从经典到新番全覆盖，小蓝视频独家授权，追番不等待。',
    alt: '小蓝视频动漫专区推荐',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20with%20romantic%20atmosphere%2C%20two%20characters%20in%20cherry%20blossom%20setting%2C%20soft%20warm%20lighting%2C%20emotional%20cinematic%20composition%2C%20Korean%20film%20aesthetic%2C%20dreamy%20color%20palette&width=600&height=400&seq=card-03&orientation=landscape',
    title: '豆花视频韩剧合集 · 高分韩剧免费看',
    desc: '豆花视频免费提供全网热门韩剧全集，从爱情到悬疑，无需付费解锁全部内容。',
    alt: '豆花视频韩剧免费合集',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20set%20with%20colorful%20lighting%20and%20stage%20design%2C%20entertainment%20show%20atmosphere%2C%20bright%20energetic%20vibe%2C%20professional%20TV%20production%20look%2C%20warm%20and%20vibrant%20color%20scheme&width=600&height=400&seq=card-04&orientation=landscape',
    title: '久久视频综艺频道 · 热门综艺每日更新',
    desc: '国内热门综艺一网打尽，久久视频稳定流畅播放，让你不错过每一期精彩内容。',
    alt: '久久视频热门综艺频道',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20scene%20with%20futuristic%20city%20skyline%2C%20neon%20lights%20and%20holographic%20displays%2C%20cyberpunk%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20sleek%20futuristic%20atmosphere&width=600&height=400&seq=card-05&orientation=landscape',
    title: '小蓝视频科幻专场 · 硬核科幻一次看爽',
    desc: '从小蓝视频精选科幻大片合集，高画质流畅播放，带给你沉浸式的未来世界体验。',
    alt: '小蓝视频科幻电影专场',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20scene%20with%20bright%20warm%20colors%2C%20funny%20character%20expressions%2C%20lighthearted%20atmosphere%2C%20comedic%20timing%20moment%2C%20cozy%20home%20setting%2C%20feel%20good%20vibe&width=600&height=400&seq=card-06&orientation=landscape',
    title: '豆花视频喜剧院线 · 欢乐时光笑不停',
    desc: '豆花视频喜剧电影专区，收录国内外经典喜剧佳作，免费观看让你笑到停不下来。',
    alt: '豆花视频喜剧电影专区',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20scene%20with%20mysterious%20dark%20atmosphere%2C%20dramatic%20shadows%20and%20contrast%20lighting%2C%20suspense%20filled%20composition%2C%20noir%20cinematography%20style%2C%20tense%20mood%2C%20professional%20film%20look&width=600&height=400&seq=card-07&orientation=landscape',
    title: '久久视频悬疑剧场 · 烧脑剧情挑战智商',
    desc: '久久视频悬疑推理电影专题，精选高分烧脑大片，高清流畅播放带你进入推理世界。',
    alt: '久久视频悬疑推理剧场',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">内容精选</h2>
            <p className="text-sm md:text-base text-foreground-600">
              久久视频、小蓝视频、豆花视频三大平台精选内容，全方位满足你的观影需求
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.slice(0, 6).map((item, i) => (
              <article key={i} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
                <div className="aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.alt}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="mt-5">
            <article className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 aspect-[3/2] md:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={cardItems[6].img}
                    alt={cardItems[6].alt}
                    title={cardItems[6].title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div className="md:w-3/5 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {cardItems[6].title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{cardItems[6].desc}</p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}